import { render } from "./categoriespage.vue?vue&type=template&id=195706f1"
import script from "./categoriespage.vue?vue&type=script&lang=js"
export * from "./categoriespage.vue?vue&type=script&lang=js"

import "./categoriespage.vue?vue&type=style&index=0&id=195706f1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__